import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import Header from './Header';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import SubjectItem from './Marksheet/SubjectItem';
import MarkSheetItem from './Marksheet/MarkSheetItem';




class UploadMarks extends Component {
    
    constructor(props)
    {
        super(props);

        this.fetchSubjects = this.fetchSubjects.bind(this);
        this.fetchMarksheet = this.fetchMarksheet.bind(this);
        this.generatePDF = this.generatePDF.bind(this);
        this.submitMarksheet = this.submitMarksheet.bind(this);

     
    
        this.exitMarksheet = this.exitMarksheet.bind(this);
        this.viewMarkSheet = this.viewMarkSheet.bind(this);
        this.updateAttendance = this.updateAttendance.bind(this);
        this.updateCAT = this.updateCAT.bind(this);
        this.updateEXAM = this.updateEXAM.bind(this);


        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
          

            apiError: true,
            apiResponse:"",

            subjects:[],
            currentMarkSheet:[],
            selectedSubject:{},
            grading:[],
           

            


            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false

        }

       
    }

    


    

  generatePDF()
  {
    const input = document.getElementById('marksheet');

    html2canvas(input)
    .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 10, 20, 190, 267);
        let filename = "Marksheet_";
        filename = filename + "_"+this.props.staff_details.core_details.EmpNo;
        filename = filename+".pdf";
        filename= filename.replace(/\s/g, "");
        pdf.save(filename);
      });

  }

    viewMarkSheet(selectedMode, selSubject)
      {
        console.log(" subject passed ", selSubject);
        this.setState({mode:selectedMode, selectedSubject:selSubject});
        this.fetchMarksheet(selSubject);
      }

    

      updateAttendance(admnNo, att)
      {
        

        for(let l= 0; l < this.state.currentMarkSheet.length; l++)
        {
          console.log("current entry ", this.state.currentMarkSheet[l].AdmnNo );

          if(this.state.currentMarkSheet[l].AdmnNo === admnNo)
          {
            console.log("inside if block");
            this.state.currentMarkSheet[l].Att = att;

            break;
          }
        }

      }

      updateCAT(admnNo, cat)
      {
        

        for(let l= 0; l < this.state.currentMarkSheet.length; l++)
        {
          console.log("current entry ", this.state.currentMarkSheet[l].AdmnNo );

          if(this.state.currentMarkSheet[l].AdmnNo === admnNo)
          {
            console.log("inside if block");
            this.state.currentMarkSheet[l].CAT = cat;

            break;
          }
        }

      }

      updateEXAM(admnNo, exam)
      {
        

        for(let l= 0; l < this.state.currentMarkSheet.length; l++)
        {
          console.log("current entry ", this.state.currentMarkSheet[l].AdmnNo );

          if(this.state.currentMarkSheet[l].AdmnNo === admnNo)
          {
            console.log("inside if block , exam ", this.state.currentMarkSheet[l].EXAM);
            this.state.currentMarkSheet[l].EXAM = exam;
            console.log("new exam ", this.state.currentMarkSheet[l].EXAM);

            break;
          }
        }

      }
    
    onClickAdd()
      {
        this.setState({mode:1});
      }
    
      exitMarksheet()
      {
        console.log("back clicked");
       
        if (window.confirm('Are you sure you want to exit the marksheet, before submitting any further update?'))
        {
          this.setState({mode:0,currentMarkSheet:[], selectedSubject:{}});
        }
         
      }

 


  fetchSubjects()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/lecturer/getsubjects";


            superagent
            .post(url)
            .send({staff_number:_this.props.staff_details.core_details.EmpNo})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                _this.setState({apiError:res.body.error,
                                apiResponse:res.body.message,
                                subjects:res.body.subjects,
                                loading:false, loaded_successfully:true,server_changes_made:true});

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, apiError:true,loaded_successfully:false, apiResponse:err,server_changes_made:true});
            });

  }

  submitMarksheet()
  {

            this.setState({loading:true});
            let _this = this;
            let message = "";

            const url = this.props.base_url +"/lecturer/updatemarksheet";


            superagent
            .post(url)
            .send({marksheet:_this.state.currentMarkSheet})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                message = res.body.message;
                console.log("Response", res.body);
                _this.setState({loading:false, loaded_successfully:true,server_changes_made:true});

                window.alert(message);

                
                

            })
            .catch(function(err){

                console.log("error response", err);
                message = err;
                _this.setState({loading:false, loaded_successfully:false, apiResponse:err});

                window.alert(message);
                
            });

           

  }

  fetchMarksheet(selSubject)
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/lecturer/getmarksheet";
            console.log("subject ", _this.state.selectedSubject.Subject);


            superagent
            .post(url)
            .send({
              clas:selSubject.Class,
              subject:selSubject.Subject
            })
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                _this.setState({apiError:res.body.error,
                                apiResponse:res.body.message,
                                currentMarkSheet:res.body.marksheet,
                                grading:res.body.grading,
                                loading:false, loaded_successfully:true,server_changes_made:true});

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, apiError:true,loaded_successfully:false, apiResponse:err,server_changes_made:true});
            });

  }







  renderErrorMessage()
  {
    const _this = this;

      if(this.state.apiError && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.apiResponse}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  renderNumberOfStudents()
  {
    const _this = this;
      if(this.state.currentMarkSheet != undefined && this.state.currentMarkSheet.length > 0 )
      {
          return(
           
            <span className = "number-of-students" >
               A total of  {" " + _this.state.currentMarkSheet.length + " "} students
            </span>
       

          );
      }
      else{
          return null;
      }
  }

  
  

  renderSubjects()
  {
    const _this = this;
    console.log("Subjects loaded ", _this.state.subjects);
      if( _this.state.subjects && _this.state.subjects.length > 0)
      {
        let subjectListing = _this.state.subjects.map((subject) => {

            return(
              <span className = "row full-width">
                <span className="col-lg-2">{subject.Class}</span>
                <span className="col-lg-2">{subject.Subject}</span>
                <span className="col-lg-6 ">{subject.Names}</span>
                <span className="col-lg-2 "><button type="submit" className="btn btn-green"> View Marksheet <div className="ripple-container"></div></button></span>
              </span>
            );
            });

        return(
            <div>
                {subjectListing}
            </div>

        );
      }
      else{
          return null;
      }
  }


  

  componentWillMount()
  {
    this.fetchSubjects();
  }


  render() {

    const _this=this;

    let subject_list;
    let marksheet_list;
    let card_content;

    if(_this.state.subjects && _this.state.subjects.length > 0)
    {
        subject_list = _this.state.subjects.map(subject =>
            {
            return (
                <SubjectItem key={subject.Subject} subject_details = {subject} viewMarkSheet={_this.viewMarkSheet} />
                    );
            });
    }
    else
    {
        subject_list=<tr> <p>No subject assigned to you yet.</p> </tr>;
    }


    if(_this.state.currentMarkSheet && _this.state.currentMarkSheet.length > 0)
    {
        marksheet_list = _this.state.currentMarkSheet.map(marksheet =>
            {
            return (
                <MarkSheetItem key={marksheet.AdmnNo} marksheet_details = {marksheet} grading = {_this.state.grading} updateAttendance={_this.updateAttendance} updateCAT={_this.updateCAT} updateEXAM={_this.updateEXAM}   />
                    );
            });
    }
    else
    {
        marksheet_list=<p className = "error-feedback">Marksheet not available. Please contact your department.</p> ;
    }

   

        if(1 === this.state.mode )
        {
            card_content =  <div className="full-width">
            <div className="col-lg-12 col-md-12">
                <div className="card full-width">
                    <div className="col-lg-12 col-md-12">
                    <button className="btn btn-danger btn-round right" onClick={_this.exitMarksheet.bind(_this)} >Exit<div className="ripple-container"></div></button>
                      <button className="btn btn-primary btn-round right" onClick={_this.generatePDF.bind(_this)} >Download<div className="ripple-container"></div></button>
                     
                    </div>

                    <div className="card-body">
                        <div className="tab-content block-centered">
                            <div className="tab-pane active" id="marksheet">
                                
                                <div className = "ms-top" className ="row block-centered col-lg-12 col-md-12 full-width">
                                  <span className="col-lg-12 block-centered"><center><img src ="/img/logotuc.png" className="header-logo center"/> </center></span>
                                  <span className = "col-lg-12 center-align times-n ms-top-name">TURKANA UNIVERSITY COLLEGE</span>
                                  <span className = "col-lg-12 center-align comic ms-top-title">MARKS LIST</span>
                                </div>

                                <div className ="ms-header row col-lg-12 col-md-12 full-width">
                                  <span className = "col-lg-12 " style={{paddingLeft:"0px"}}> 
                                    <span className="marksheet-title">LECTURER :</span><span className="marksheet-info comic">{" [ " + (_this.props.staff_details.core_details.EmpNo).split("/")[1] +" "+ _this.props.staff_details.core_details.Names +"]"}</span>
                                  </span>

                                  <span className = "col-lg-12 " style={{paddingLeft:"0px"}}> 
                                      <span className="marksheet-title">SUBJECT : </span><span className="marksheet-info comic">{" " + _this.state.selectedSubject.Subject + " - " + _this.state.selectedSubject.Names}</span>
                                  </span>

                                  <span className = "col-lg-12 " style={{paddingLeft:"0px"}}>
                                      <span className="marksheet-title">CLASS : </span><span className="marksheet-info comic">{" " + _this.state.selectedSubject.Class + " - " + ((_this.state.currentMarkSheet != undefined && _this.state.currentMarkSheet.length > 0) ? _this.state.currentMarkSheet[0].programme: "")}</span> 
                                    
                                        
                                  </span>

                                  <span className = "col-lg-12 " style={{paddingLeft:"0px"}}> 
                                    
                                  <span className="marksheet-title">SEMESTER : </span><span className="marksheet-info comic">{" " + ((_this.state.currentMarkSheet != undefined && _this.state.currentMarkSheet.length > 0) ? _this.state.currentMarkSheet[0].Term : "")}</span> 
                                  </span>
                                  
                                </div>


                              
                                <table className ="ms-table">
                                        <thead className="table-ms-heading">
                                            <tr>

                                                <th width = "20%">AdmnNo</th>
                                                <th width = "30%">Names</th>
                                                <th width = "10%">ATT</th>
                                                <th width = "10%">CAT</th>
                                                <th width = "10%">EXAM</th>
                                                <th width = "10%">TOTAL</th>
                                                <th width = "10%" >Grade</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {marksheet_list}
                                           
                                        </tbody>
                                    </table>

                                    {_this.renderNumberOfStudents()}

                                    <hr className = "divider full-width" />

                                  
                                      <span className = "row col-lg-12 full-width " style={{paddingLeft:"0px"}}>
                                          <span className ="col-lg-6">Lecturer: <span className ="comic handwritten">{"[ " + (_this.props.staff_details.core_details.EmpNo).split("/")[1] +" "+ _this.props.staff_details.core_details.Names +"]"}</span> </span> 
                                          <span className ="col-lg-3">Sign:......................</span>
                                          <span className ="col-lg-3">Date:......................</span>
                                      </span>

                                      <span className = "row col-lg-12 full-width " style={{paddingLeft:"0px"}}>
                                          <span className ="col-lg-6">Received by: .................................................</span> 
                                          <span className ="col-lg-3">Sign:.....................</span>
                                          <span className ="col-lg-3">Date:.....................</span>
                                      </span>
                                      
                          
                                

                            </div>

                            <div className="col-lg-12 col-md-12">
                                  <button className="btn btn-primary btn-round right" onClick={_this.submitMarksheet.bind(_this)}  >SUBMIT MARKS<div className="ripple-container"></div></button>
                                </div>
                        </div>
                    </div>
                </div>
            </div>

       </div>;
        }


        else
        {
            card_content =  <div className="full-width">
            <div className="col-lg-12 col-md-12">
                <div className="card full-width">
                    <div className="card-body">
                        <div className="tab-content block-centered">
                            <div className="tab-pane active" id="profile">
                                <h4 className ="text-center times-n ms-top-name" style ={{fontWeight:"style"}}>SUBJECTS/CLASS ASSIGNED</h4>
                                <table>
                                        <thead className="table-ms-heading">
                                            <tr>

                                                <th>Class</th>
                                                <th>Subject</th>
                                                <th>Title</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {subject_list}
                                            {_this.renderErrorMessage()}
                                        </tbody>
                                    </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

       </div>;
       
        }

    


    if(this.state.loading)
    {
        return(

            <div className="main-panel">

              <Header title = "Upload Marks" />


              <div className="content">
                  <div className="container-fluid">
                      <div className="row">
                        Loading, Please wait......
                        <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                      </div>
                </div>
              </div>
            </div>

        );
    }

    return (
      <div className="main-panel">

        <Header title ="Upload Marks" />

        <div className="content">
            <div className="container-fluid">
                {card_content}

            </div>
            </div>


            

            </div>





    );
  }
}

export default UploadMarks;
